import { render, staticRenderFns } from "./QuestionBankFile.vue?vue&type=template&id=8a7d193a"
import script from "./QuestionBankFile.vue?vue&type=script&lang=js"
export * from "./QuestionBankFile.vue?vue&type=script&lang=js"
import style0 from "./QuestionBankFile.vue?vue&type=style&index=0&id=8a7d193a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports